import { render, staticRenderFns } from "./TempoControl.vue?vue&type=template&id=c0dd9282&"
import script from "./TempoControl.vue?vue&type=script&lang=js&"
export * from "./TempoControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports